import Store from './store/index';
import { sanCube } from './scanSingleCube';

export function add(cubeId: CubeId): void {
    let singleCubeCoordinate: PhysicsCoordinate|null = sanCube(cubeId);

    if (singleCubeCoordinate) {
        Store.setCoordinate(cubeId, singleCubeCoordinate);
    }
}

// 直接调用add方法，update用于更新，明确语意
export function update(cubeId: CubeId): void {
    add(cubeId);
}
